import React, { useState, useEffect } from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { CreateTableNew as CreateTable } from '../../../../common/APICommon';

export const FixedLogsUploadForm = ({ isOpen, onClose, hookProps, allEmployees, activeVessels }) => {
  const { uploadPreview, setUploadPreview, processExcel, uploadBulk, uploadLoading } = hookProps;
  const [currentPage, setCurrentPage] = useState(1);
  const [files, setFiles] = useState([]);

  const hasErrors = uploadPreview.some(item => item.errors && item.errors.length > 0);
  const hasData = uploadPreview.length > 0;

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
    if (fileList[0]) processExcel(fileList[0], allEmployees, activeVessels);
  };

  const clearFiles = () => {
    setFiles([]);
    setUploadPreview([]);
    if (document.getElementById('fileInputFixed')) document.getElementById('fileInputFixed').value = '';
  };

  const customRenderer = (row, accessor) => {
    // Handle Date Columns
    if (accessor === "dateFrom" || accessor === "dateTo") {
      const val = row[accessor];

      // If the hook flagged it as INVALID
      if (val === "INVALID") {
        return <span className="text-red-500 font-bold">NaN</span>;
      }

      // If valid, the hook provided "YYYY-MM-DD"
      const parts = val.split('-');
      if (parts.length === 3) {
        const [year, month, day] = parts;
        const months = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        const monthName = months[parseInt(month, 10) - 1];
        return <span className="whitespace-nowrap">{`${monthName} ${day}, ${year}`}</span>;
      }
      return val;
    }

    // Handle Error Column
    if (accessor === "errors" && row.errors) {
      return (
        <div className="flex flex-col gap-1 py-1 min-w-[300px]">
          {row.errors.split('. ').map((msg, i) => (
            msg && <div key={i} className="text-red-600 font-semibold text-xs">• {msg}</div>
          ))}
        </div>
      );
    }

    return null;
  };

  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      <div className="modal" style={{ width: '90%', maxWidth: '1200px' }}>
        <div className="popUp-header row">
          <div className="popUp-title"><h3 style={{ color: "#668fca" }}>Upload Fixed Logs Config</h3></div>
          <div className="popUp-close"><CloseIcon onClick={onClose} className="cursor-pointer" /></div>
        </div>

        <div className="p-6 overflow-y-auto max-h-[80vh]">
          <div className="mb-4">
            <label htmlFor="fileInputFixed" className='browse cursor-pointer inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700'>
              Browse Excel...
            </label>
            <input type="file" id="fileInputFixed" onChange={handleBrowse} className="hidden" accept=".xlsx, .xls" />

            {files.length > 0 && (
              <div className="mt-3 p-3 bg-gray-50 border rounded flex justify-between items-center">
                <span className="text-sm font-medium">Selected: {files[0].name}</span>
                <button onClick={clearFiles} className="text-xs text-red-500 hover:underline">Clear</button>
              </div>
            )}
          </div>

          {hasData && (
            <>
              <div className={`p-3 mb-4 rounded text-white font-bold ${!hasErrors ? 'bg-green-500' : 'bg-red-500'}`}>
                {!hasErrors ? "✓ Data is valid and ready." : "⚠ Data contains errors. Please correct the Excel file."}
              </div>

              <CreateTable
                tableName="FixedLogsUploadPreview"
                headers={["Employee Id", "Employee Name", "Date From", "Date To", "Vessel Name", "Errors"]}
                accessors={["employeeId", "fullName", "dateFrom", "dateTo", "vesselName", "errors"]}
                data={uploadPreview}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={uploadPreview.length}
                customCellRenderer={customRenderer}
              />
            </>
          )}

          <div className="flex justify-end gap-3 mt-6">
            <button onClick={onClose} className="px-6 py-2 bg-gray-400 text-white rounded hover:bg-gray-500">Cancel</button>
            <button
              disabled={!hasData || hasErrors || uploadLoading}
              onClick={() => uploadBulk(onClose)}
              className={`px-8 py-2 rounded text-white font-bold ${!hasData || hasErrors ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
            >
              {uploadLoading ? "Uploading..." : "Confirm Upload"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};